export enum ConfigLevelType {
  AGENCY = <any>'AGENCY',
  BRAND = <any>'BRAND',
  CHAIN = <any>'CHAIN',
  PROPERTY = <any>'PROPERTY',
  SYSTEM = <any>'SYSTEM',
  UNKNOWN = <any>'UNKNOWN'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/config-level-type.ts